import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SportsTitleCasePipe } from "@sports-pipes/index";
import { LIVE_MARKET_FILTER_TYPES } from "src/app/modules/sports/utils/sports.constants";
@Component({
  standalone: true,
  selector: "sports-live-navbar",
  templateUrl: "./sports-live-navbar.html",
  imports: [CommonModule, FormsModule, SportsTitleCasePipe],
  styleUrls: ["./sports-live-navbar.scss"],
})
export class SportsLiveNavbarComponent {
  @Input() hasBackButton: boolean;
  @Input() light: boolean;
  @Input() title = "Ahora en Directo";
  @Input() breadcrumbs: string[] = [];
  @Output() close: EventEmitter<any> = new EventEmitter();

  @Output() setFilterType = new EventEmitter<string>();

  @Input() hideFilterSportradar: boolean = true;
  @Input() hideFilterVideoStreaming: boolean = true;
  @Input() hideFilterScoreboard: boolean = true;
  @Input() isSportradarActive: boolean = false;
  @Input() isVideoStreamingActive: boolean = false;
  @Input() isScoreboardActive: boolean = false;

  LIVE_MARKET_FILTER_TYPES = LIVE_MARKET_FILTER_TYPES;
}
